import { RefObject } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import Button from 'src/components/common/Button';
import CertificationNumberVerify from 'src/components/join/CertificationNumberVerify';
import PhoneNumberCertification from 'src/components/join/PhoneNumberCertification';
import Terms from 'src/components/join/Terms';
import { RecoilCommonList } from 'src/recoil/common';
import { TelecomTypeState, TransIdState } from 'src/recoil/join';
import {
  CertNumberSubmitState,
  RecoilUiList,
} from 'src/recoil/ui';
import styled from 'styled-components';
import Loading from '../common/Loading';
import useAPI from 'src/hooks/useApi';

const ButtonWrap = styled.div`
  > button:first-child {
    margin-bottom: 10px;
  }
`;
const PhoneNumberCertificationWrap = styled.div<{borderColor: string, backgroundColor: string}>`
  background-color: ${(props) => props.backgroundColor ?? 'none'};
  border: 3px solid ${(props) => props.borderColor ?? 'none'};
  border-radius: 5px;
  margin: 10px auto 0 auto ;
  padding: 10px 13.5px 15px;
`

export interface JoinCertificationProp {
  phoneNumberRef?: RefObject<HTMLInputElement>;
  handleFocus?: () => void;
  submit: any
}

const JoinCertification = (props: JoinCertificationProp) => {
  const { phoneNumberRef, handleFocus, submit } = props;

  const transId = useRecoilValue(TransIdState);
  const telecomType = useRecoilValue(TelecomTypeState);
  const {pCode, requestId, userAgent } = useRecoilValue(RecoilCommonList)
  const {joinStep, partner, termsAgree, termsData } = useRecoilValue(RecoilUiList)
  const [certNumberSubmit,setCertNumberSubmit] = useRecoilState(CertNumberSubmitState);

  const CertApi = useAPI('sendcaptchaexpress')
  const JoinApi = useAPI('sendotpverfy')

  const {
    phoneInput,
    certificationInput,
    handleReset,
    vulnerableLoading,
    isJoinSubmitting: joinSubmitting,
    isCertSubmitting,
  } = submit
  const {
    value: phoneNumber,
    onChangeHandler: phoneNumberChange,
  } = phoneInput
  const {
    value: certificationNumber,
    onChangeHandler: certificationNumberChange,
    onResetHandler: certificationNumberReset,
  } = certificationInput

  const { mutateAsync: JoinRequest, isLoading: joinLoading } = JoinApi.useSetMutation({
    Telecom: telecomType,
    PNumber: phoneNumber,
    TranID: transId,
    ApprovalNumber: Number(certificationNumber),
    PCode: pCode,
    RequestID: requestId,
    CALLTYPE: userAgent,
    TermsIdx: termsData.TermsIdx,
    TermsAgree: termsAgree.join(""),
  })
  const { mutateAsync: getSendOtp, isLoading: certLoading } = CertApi.useSetMutation({
    Telecom: telecomType,
    PNumber: phoneNumber,
    PCode: pCode,
    RequestID: requestId,
  })

  // 선행 취약계층 확인 + 모달 대기 + 가입 API 전 구간을 하나의 pending으로 본다.
  const isJoinSubmitting = joinSubmitting || vulnerableLoading || joinLoading
  const isCertPending = isCertSubmitting || certLoading

  const handleJoinSubmit = () => {
    if (isJoinSubmitting) return
    submit.join(JoinRequest)
  }

  const handleCertSubmit = () => {
    if (isCertPending) return
    submit.validationCert(getSendOtp)
  }

  const reSend = () => {
    if (isCertPending) return
    if (certNumberSubmit) {
      if (window.confirm('인증번호 전송 내역이 존재합니다. \n재전송 하시겠습니까?')) {
        certificationNumberReset();
        submit.validationCert(getSendOtp)
        setCertNumberSubmit(true)
      }
    }
  };

  return (
    <>
      {(isJoinSubmitting || isCertPending) && <Loading />}
      <PhoneNumberCertificationWrap
          borderColor={partner.UiData.layoutsInsert.certs.borderColor as string}
          backgroundColor={partner.UiData.layoutsInsert.certs.backgroundColor as string}
      >
        <PhoneNumberCertification
          phoneNumber={phoneNumber}
          ref={phoneNumberRef}
          phoneNumberClassName="ipt_phonenumber"
          focusOption={{preventScroll: true}}
          onChange={phoneNumberChange}
          onDisabled={joinStep !== 0}
          onSubmit={handleCertSubmit}
          onFocus={handleFocus}
        />
        {joinStep === 0 && (
          <Button
            text="인증번호 발송"
            onClick={handleCertSubmit}
            styles={partner.UiData.layoutsConfirm.submitBtn}
            disabled={joinStep !== 0 || isCertPending}
            className="btn_send_sms"
          />
        )}
        {joinStep === 1 && (
          <CertificationNumberVerify
            certificationNumber={certificationNumber}
            certificationNumberClassName="ipt_smscode"
            onChange={certificationNumberChange}
            onReSend={reSend}
            onSubmit={handleJoinSubmit}
          />
        )}
      </PhoneNumberCertificationWrap>
      <Terms />
      <ButtonWrap>
        <Button
          text={joinStep === 0 ? partner.ButtonMsgBefore : partner.ButtonMsgAfter}
          onClick={handleJoinSubmit}
          styles={partner.UiData.layoutsVerify.verifyBtn} className="btn_signup"
          disabled={isJoinSubmitting}
        />
        <Button text="취소" onClick={handleReset} styles={partner.UiData.layoutsVerify.cancelBtn} className="btn_cancel" disabled={isJoinSubmitting} />
      </ButtonWrap>
    </>
  );
};

export default JoinCertification;
